module.exports = __webpack_public_path__ + "static/media/b.762210ed.jpg";